import { apiClient } from '@/services';
import type { ApiResponse } from '@macroinsight/shared-types';
import { z } from 'zod/v3';

const verifyOtpDataSchema = z.object({
  email: z.string().email(),
  otp: z.string().length(6),
  rememberMe: z.boolean().optional().default(false)
});

export type VerifyOtpData = z.infer<typeof verifyOtpDataSchema>;

export async function verifyOtpAction(data: VerifyOtpData): Promise<ApiResponse<any>> {
  const validatedData = verifyOtpDataSchema.parse(data);

  const response = await apiClient.post<any>('/api/auth/verify-otp', validatedData);

  return response;
}
